import React from "react"
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image"
import type { ImageType } from "./types"

const Image = ({ image, ...props }: ImageType) => {
    if (image?.file?.extension === "svg") {
        return <img alt={image?.alternativeText || ""} src={image.file.publicURL} {...props} />
    }

    const imageData = getImage(image.file as unknown as ImageDataLike)

    return imageData
        ? <GatsbyImage alt={image?.alternativeText || ""} image={imageData} {...props} />
        : null
}

export default Image
